module.exports = __webpack_public_path__ + "static/media/clamens.45b54b09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pictures/clamens.jpg
// module id = 322
// module chunks = 0